<template>
    <div class="four_table">
        <div class="inputCont">
            <el-form
                style="width: 100%"
                :model="searchForm"
                class="leader-style-form leader-form-inner-tab-inline"
                :inline="true"
            >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="设备名称">
                            <el-input v-model="searchForm.device_ledger_name" maxlength="50"></el-input>
                        </el-form-item>
                        <el-form-item label="设备类型" prop="device_ledger_type" label-width="120px">
                            <el-select
                                v-model="searchForm.device_ledger_type"
                                placeholder="请选择设备类型"
                                style="width: 100%"
                                clearable
                            >
                                <el-option
                                    v-for="item in deviceLedgerList"
                                    :key="item.code_value"
                                    :label="item.code_name"
                                    :value="item.code_value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                        <el-button
                            @click="getDeviceLedgerList"
                            size="small"
                            class="leader-common-button"
                        >查询</el-button>
                        <el-button class="leader-common-button" @click="addItem" size="small">新增</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <!-- -------------------------- -->
        <!-- table布局 -->
        <div class="table-wrap" style="height: 100%; width: 100%" v-loading="loading">
            <el-table
                class="leader-style-table"
                :data="tableList"
                ref="multipleTable"
                height="100%;"
            >
                <el-table-column label="设备名称" property="device_ledger_name"></el-table-column>
                <el-table-column label="设备类型" property="device_ledger_type_name"></el-table-column>
                <el-table-column label="设备序号" property="device_number"></el-table-column>
                <el-table-column label="设备变比" property="device_ratio"></el-table-column>
                <el-table-column label="主要参数指标" property="main_parameters"></el-table-column>
                <el-table-column label="状态" property="device_status_name"></el-table-column>
                <el-table-column label="制造厂" property="manufacturer"></el-table-column>
                <el-table-column label="出厂编号" property="serial_number" align="center"></el-table-column>
                <el-table-column label="投运日期" property="up_time" align="center"></el-table-column>
                <el-table-column label="产权单位" property="property_unit" align="center"></el-table-column>
                <el-table-column label="制造厂" property="manufacturer" align="center"></el-table-column>
                <el-table-column label="设备状态" property="device_status_name" align="center"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="viewItem(scope.row)"
                            type="text"
                            class="leader-button start-button"
                        >
                            <i class="iconfont iconchakan"></i>
                            <span class="inner-text">查看</span>
                        </el-button>
                        <el-button
                            @click="changeItem(scope.row)"
                            type="text"
                            class="leader-button edit-button"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="deleteItemShow(scope.row)"
                            type="text"
                            class="leader-button del-button"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
                v-if="this.paginationData.totalNum"
            ></pagination>
        </div>
        <!-- -------------------------------- -->
        <!-- 新增dialog -->
        <el-dialog
            title="变电所台账管理"
            class="leader-dialog"
            :visible.sync="addshow"
            :close-on-click-modal="false"
            @close="dialogClose('commitForm')"
        >
            <el-scrollbar class="equipment_scroll">
                <div class="equipment_add_b_container">
                    <div class="equipment_add_b">
                        <div class="el-card1">
                            <div class="leader-title" style="margin-top: 20px">柜内设备选择</div>
                            <div class="tree-wrap">
                                <el-checkbox-group v-model="checkList" @change="leftChange">
                                    <el-checkbox
                                        v-for="checkItem in shebeiChecklist"
                                        :label="checkItem.code_name"
                                        :key="checkItem.code_value"
                                    >{{ checkItem.code_name }}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                        <div class="right_container" v-loading="loading">
                            <div class="table-wrap-inner">
                                <el-form
                                    :model="commitForm"
                                    ref="commitForm"
                                    class="leader-style-form"
                                >
                                    <el-table
                                        :data="commitForm.tableData"
                                        class="leader-style-table leader-style-table-no"
                                    >
                                        <el-table-column prop="a" label="所属配电柜"></el-table-column>
                                        <el-table-column
                                            prop="device_ledger_type_name"
                                            label="设备类型"
                                        ></el-table-column>
                                        <el-table-column prop="device_ledger_name" label="设备名称"></el-table-column>
                                        <el-table-column prop="amount" label="数量">
                                            <template slot-scope="scope">
                                                <el-form-item
                                                    :prop="'tableData.' + scope.$index + '.amount'"
                                                    :rules="[
                                                        {
                                                            required: true,
                                                            message: '请输入本期值',
                                                            trigger: 'blur'
                                                        }
                                                    ]"
                                                    :show-message="false"
                                                >
                                                    <el-input
                                                        maxlength="6"
                                                        v-model="scope.row.amount"
                                                        v-Int
                                                        autocomplete="off"
                                                    ></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onReset" class="leader-common-button">取消</el-button>
                <el-button class="leader-common-button" @click="addcommit">保存</el-button>
            </div>
        </el-dialog>

        <!-- 修改dialog -->
        <el-dialog
            title="变电所台账管理"
            class="leader-dialog"
            :visible.sync="modshow"
            :close-on-click-modal="false"
            @close="dialogClose('addForm')"
        >
            <div class="substation_outer_wrapper">
                <div class="table-container" style="width: 100%;">
                    <el-form
                        label-width="150px"
                        :model="addForm"
                        :rules="addRules"
                        ref="addForm"
                        class="leader-style-form"
                        :show-message="false"
                    >
                        <el-scrollbar style="height: 22rem;margin-right: -1px">
                            <el-row :gutter="20">
                                <div class="circle_wrapper">
                                    <div class="circle_title">运行参数</div>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备名称"
                                            prop="device_ledger_name"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.device_ledger_name"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备类型"
                                            prop="device_ledger_type"
                                            label-width="120px"
                                        >
                                            <el-select
                                                v-model="addForm.device_ledger_type"
                                                placeholder="设备类型"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in deviceLedgerList"
                                                    :key="item.code_value"
                                                    :label="item.code_name"
                                                    :value="item.code_value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备序号"
                                            prop="device_number"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.device_number"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备型号"
                                            prop="device_model"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.device_model"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备状态"
                                            prop="device_status"
                                            label-width="120px"
                                        >
                                            <el-select
                                                v-model="addForm.device_status"
                                                placeholder="请选择设备状态"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in deviceStatusList"
                                                    :key="item.code_value"
                                                    :label="item.code_name"
                                                    :value="item.code_value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="出厂编号"
                                            prop="serial_number"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.serial_number"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="主要指标参数"
                                            prop="main_parameters"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.main_parameters"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="投运日期"
                                            prop="up_time"
                                            label-width="120px"
                                        >
                                            <el-date-picker
                                                v-model="addForm.up_time"
                                                align="right"
                                                type="date"
                                                :clearable="false"
                                                placeholder="选择日期"
                                                value-format="yyyy-MM-dd"
                                                :picker-options="pickerOptions"
                                            ></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="数量" prop="amount" label-width="120px">
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.amount"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备电压等级"
                                            prop="voltage_level"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.voltage_level"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备变比"
                                            prop="device_ratio"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.device_ratio"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <div style="clear: both"></div>
                                </div>
                                <div class="circle_wrapper">
                                    <div class="circle_title">资产参数</div>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="产权单位"
                                            prop="property_unit"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.property_unit"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="所属单位"
                                            prop="affiliation"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.affiliation"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="附件"
                                            label-width="120px"
                                            prop="device_url_name"
                                        >
                                            <div style="display: flex; align-items: center;">
                                                <div
                                                    v-if="addForm.device_url_name"
                                                    style="width: calc(100% - 40px);color: #fff;"
                                                >
                                                    <a
                                                        :download="addForm.device_url_name"
                                                        :href="addForm.all_device_url"
                                                    >{{ addForm.device_url_name }}</a>
                                                    <i
                                                        @click="deleteFile()"
                                                        class="el-icon-delete"
                                                        style="font-size: 18px;color: red;cursor: pointer;margin-left: 5px;"
                                                    ></i>
                                                </div>
                                                <el-upload
                                                    class="upload-demo"
                                                    action
                                                    :show-file-list="false"
                                                    ref="fjupload"
                                                    :http-request="doUploadFile"
                                                    accept=".doc, .docx, .ppt, .pptx, .xls, .xlsx, .txt, .pdf, .jpg, .png"
                                                    :on-exceed="handleExceed"
                                                >
                                                    <el-button size="small" type="primary">点击上传</el-button>
                                                </el-upload>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <div style="clear: both"></div>
                                </div>
                                <div class="circle_wrapper">
                                    <div class="circle_title">物理参数</div>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="制造厂"
                                            prop="manufacturer"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.manufacturer"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="使用地点"
                                            prop="use_place"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.use_place"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="设备原值"
                                            prop="former_value"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.former_value"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="防护等级"
                                            prop="protection_level"
                                            label-width="120px"
                                        >
                                            <el-input
                                                maxlength="32"
                                                v-model="addForm.protection_level"
                                                autocomplete="off"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="备注" label-width="120px" prop="remark">
                                            <el-input
                                                type="textarea"
                                                :rows="6"
                                                maxlength="200"
                                                v-model="addForm.remark"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <div style="clear: both"></div>
                                </div>
                            </el-row>
                        </el-scrollbar>
                    </el-form>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    @click="addshow = false; modshow = false;"
                    class="leader-common-button"
                    size="small"
                >取 消</el-button>
                <el-button
                    type="primary"
                    @click="addcommit"
                    :disabled="this.$store.state.btnType"
                    size="small"
                    class="leader-common-button"
                >确 定</el-button>
            </div>
        </el-dialog>

        <!-- 查看dialog -->
        <el-dialog
            class="leader-dialog equipment_dialog"
            title="查看"
            :visible.sync="detailsShow"
            :close-on-click-modal="false"
        >
            <!-- <div class="circle_wrapper">
            <div class="circle_title">其他参数</div>-->
            <el-scrollbar style="height: 22rem;margin-right: -1px">
                <div v-for="(value, key) in detailTableData" :key="key" class="circle_wrapper">
                    <div class="circle_title">{{ key }}</div>
                    <mailTable :tableData="value" :tableStyle="{ width: '100%' }"></mailTable>
                </div>
            </el-scrollbar>
        </el-dialog>
    </div>
</template>
<script>
import { getCodelistByKind, uploadAvatar } from "@/http/api.js";
import * as api from "../api/substation_device_manage";
import Collapes from "@/comon/components/collapse-block.vue";
import pagination from "@/comon/components/pagination.vue";
import mailTable from "@/comon/components/TableComponent.vue";
export default {
    components: {
        pagination,
        "me-collapes": Collapes,
        mailTable: mailTable
    },
    // props: {
    //     from: String,
    //     secondStepData: Object,
    //     shebeiChecklist: Object,
    //     currentTreeNode: Object,
    //     currentTreeTypeId: String,
    // },
    props: ["treeId", "treeLevel", "treeData"],
    data() {
        return {
            tableList: [],
            tableId: "",
            paginationData: {
                pageNum: "",
                pageSize: "",
                totalNum: "",
            },
            searchForm: {
                device_ledger_name: '',
                device_ledger_type: "",
            },
            addshow: false,
            modshow: false,
            addForm: {
                device_ledger_name: "",
                device_ledger_type: "",
                device_number: "",
                device_model: '',
                device_status: '',
                main_parameters: '',
                up_time: null,
                amount: '',
                voltage_level: "",
                device_ratio: "",
                property_unit: '',
                affiliation: '',
                file_id: '',
                device_url_name: '',
                device_url: '',
                all_device_url: '',
                manufacturer: '',
                use_place: '',
                former_value: '',
                protection_level: '',
                serial_number: '',
                remark: '',
            },
            addRules: {
                device_ledger_name: [
                    {
                        required: true,
                        message: "请填写设备名称",
                        trigger: "blur",
                    },
                ],
                device_ledger_type: [
                    {
                        required: true,
                        message: "请选择设备类型",
                        trigger: "change",
                    },
                ],
                device_status: [
                    {
                        required: true,
                        message: "请选择设备状态",
                        trigger: "change",
                    },
                ],
                // device_number: [
                //     {
                //         required: true,
                //         message: "请输入设备序号",
                //         trigger: "blur",
                //     },
                // ],
                // up_time: [
                //     {
                //         required: true,
                //         message: "请选择投运日期",
                //         trigger: "change",
                //     },
                // ],
                // voltage_level: [
                //     {
                //         required: true,
                //         message: "请输入设备电压等级",
                //         trigger: "blur",
                //     },
                // ],
            },
            checkList: [],
            width: "630px",
            commitForm: {
                tableData: [],
            },
            macChecklist: [],
            shebeiChecklist: [],
            isAdd: true,
            detailsShow: false,
            deviceStatusList: [],
            detailTableData: {},
        };
    },
    created() {
        this.getCodelistByKind();
    },
    methods: {
        getCodelistByKind() {
            getCodelistByKind({
                code_kind: "device_ledger_type_50;device_status",
            }).then((res) => {
                if (res) {
                    this.shebeiChecklist = res.bus_json[0].codelists;
                    this.deviceStatusList = res.bus_json[1].codelists;
                    this.deviceLedgerList = res.bus_json[0].codelists;
                }
            });
        },
        getDeviceLedgerList() {
            this.loading = true;
            api.getDeviceLedgerList({
                ...this.searchForm,
                p_device_ledger_id: this.treeId,
                device_ledger_kind: this.treeData.device_ledger_kind,
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize,
            }).then((res) => {
                this.tableList = res.bus_json.items;
                this.paginationData.pageNum = res.bus_json.pageNum;
                this.paginationData.pageSize = res.bus_json.pageSize;
                this.paginationData.totalNum = res.bus_json.totalNum;
                //  this.$refs.multipleTable.doLayout();
            });
            this.loading = false;
        },
        leftChange(checked) {
            const dataTemp = [];
            checked.forEach((item, index) => {
                const shebei = this.shebeiChecklist.filter(vv => vv.code_name == item);
                dataTemp.push({
                    a: this.treeData.device_ledger_name,
                    device_ledger_type: shebei && shebei.length ? shebei[0].code_value : '',
                    device_ledger_type_name: item,
                    device_ledger_name: this.treeData.device_ledger_name + item,
                    amount: 1,
                });
            });
            this.commitForm.tableData = dataTemp;
        },
        addItem() {
            this.isAdd = true;
            this.width = "calc(100% - 250px)";
            this.addshow = true;
        },
        // 新增资源提交
        addcommit() {
            if (this.isAdd) { // 新增
                this.$refs["commitForm"].validate((valid) => {
                    if (!this.treeId) {
                        this.$message({
                            message: '请选择设备',
                            type: "warning",
                        });
                        return;
                    }
                    if (!this.commitForm.tableData || !this.commitForm.tableData.length) {
                        this.$message({
                            message: '请选择柜内设备',
                            type: "warning",
                        });
                        return;
                    }
                    if (valid) {
                        const param = [
                            ...this.commitForm.tableData
                        ];
                        if (this.isAdd) {
                            param.map(item => {
                                item.p_device_ledger_id = this.treeId;
                                item.device_ledger_kind = this.treeData.device_ledger_kind;
                            })
                        }
                        api.saveDeviceLedger(param).then((res) => {
                            if (res) {
                                this.addshow = false;
                                this.$message({
                                    message: res.error_msg,
                                    type: "success",
                                });
                                this.getDeviceLedgerList();
                                this.onReset();
                            }
                        });
                    }
                });
            } else { //修改
                this.$refs["addForm"].validate((valid) => {
                    if (!this.treeId) {
                        this.$message({
                            message: '请选择设备',
                            type: "warning",
                        });
                        return;
                    }
                    if (valid) {
                        const param = [{
                            ...this.addForm
                        }];
                        api.saveDeviceLedger(param).then((res) => {
                            if (res) {
                                this.$message({
                                    message: res.error_msg,
                                    type: "success",
                                });
                                this.modshow = false;
                                this.getDeviceLedgerList();
                                this.diaClose();
                            }
                        });
                    }
                });
            }
        },
        // 所有关闭dialog的清除验证的回调
        diaClose() {
            this.addshow = false;
            this.$emit('reloadTree');
        },
        // 所有关闭dialog的清除验证的回调
        dialogClose(formName) {
            this.$nextTick(() => {
                this.$refs[formName].resetFields();
            });
        },
        // table内点击修改弹窗
        changeItem(sth) {
            this.isAdd = false;
            this.width = "100%";
            api.selectByDeviceLedgerId({
                device_ledger_id: sth.device_ledger_id,
            }).then((res) => {
                if (res) {
                    this.addForm = res.bus_json;
                    this.modshow = true;
                    // this.$nextTick(() => {
                    //     this.$refs.subtree1.$refs.tree.setCurrentKey(
                    //         this.addForm.power_supply_type_id
                    //     );
                    //     this.defaultExpandedKeys1 = [this.addForm.power_supply_type_id];
                    // });
                }
            });
        },
        viewItem(sth) {
            this.detailTableData = {};
            api.selectByDeviceLedgerId({
                device_ledger_id: sth.device_ledger_id,
            }).then((res) => {
                if (res) {
                    this.detailTableData['运行参数'] = [
                        { key: '设备名称', value: res.bus_json.device_ledger_name },
                        { key: '设备类型', value: res.bus_json.device_ledger_type_name },
                        { key: '设备序号', value: res.bus_json.device_number },
                        { key: '设备型号', value: res.bus_json.device_model },
                        { key: '设备状态', value: res.bus_json.device_status_name },
                        { key: '主要指标参数', value: res.bus_json.main_parameters },
                        { key: '投运日期', value: res.bus_json.up_time },
                        { key: '数量', value: res.bus_json.amount },
                        { key: '设备电压等级', value: res.bus_json.voltage_level },
                        { key: '设备变比', value: res.bus_json.device_ratio },
                    ];
                    this.detailTableData['资产参数'] = [
                        { key: '产权单位', value: res.bus_json.property_unit },
                        { key: '所属单位', value: res.bus_json.affiliation },
                        { key: '附件', value: res.bus_json.device_url_name ? '<a download="' + res.bus_json.device_url_name + '"  href="' + res.bus_json.all_device_url + '" >' + res.bus_json.device_url_name + '</a>' : '' },
                    ];
                    this.detailTableData['物理参数'] = [
                        { key: '制造厂', value: res.bus_json.manufacturer },
                        { key: '使用地点', value: res.bus_json.use_place },
                        { key: '设备原值', value: res.bus_json.former_value },
                        { key: '防护等级', value: res.bus_json.protection_level },
                        { key: '出厂编号', value: res.bus_json.serial_number },
                        // {key: '柜体尺寸', value: res.bus_json.cabinet_size},
                        { key: '备注', value: res.bus_json.remark },
                    ];
                    this.detailsShow = true;
                }
            });
        },
        deleteItemShow(sth) {
            this.$confirm("确认删除该数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deleteDeviceLedger({ device_ledger_id: sth.device_ledger_id }).then(res => {
                    if (res) {
                        // 最后一页，只有一条数据时，点击删除
                        if (
                            this.paginationData.totalNum -
                            (this.paginationData.pageNum - 1) *
                            this.paginationData.pageSize ==
                            1
                        ) {
                            // 处理页码显示问题
                            this.paginationData.pageNum =
                                this.paginationData.pageNum == 1
                                    ? this.paginationData.pageNum
                                    : this.paginationData.pageNum - 1;
                        }
                        // 刷新列表
                        this.getDeviceLedgerList();
                        this.diaClose();
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
        deleteFile() {
            this.addForm.file_id = '';
            this.addForm.device_url_name = '';
            this.addForm.device_url = '';
            this.addForm.all_device_url = '';
            this.$forceUpdate();
        },
        // 附件上传
        doUploadFile(file) {
            const isLt2M = file.file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 10MB!,请重新上传！");
                return;
            }
            // const file_type_name = this.$refs.fjupload.$attrs.row
            //     .file_type_name;
            let formData = new FormData();
            formData.append("file", file.file);
            formData.append("file_type", "20");
            // formData.append("file_type_name", file_type_name);
            uploadAvatar(formData).then((res) => {
                if (res && res.error_code == "0") {
                    this.addForm.file_id = res.bus_json.file_id;
                    this.addForm.device_url = res.bus_json.file_path;
                    this.addForm.all_device_url = res.bus_json.all_file_path;
                    this.addForm.device_url_name = res.bus_json.file_name;
                    this.$forceUpdate();
                    this.$message({
                        type: "success",
                        message: res.error_msg,
                    });
                }
            });
        },
        onReset() {
            this.addshow = false;
            this.checkList = [];
            this.commitForm.tableData = [];
        },
        genDeviceList() {
            const deviceList = [
                {},
            ];
            // this.checkList.forEach((item, index) => {
            //     this.shebeiChecklist.forEach((_item, _index) => {
            //         if (item == _item.tree_type_name) {
            //             const treeColumList = [];
            //             this.tableData.forEach((data, ind) => {
            //                 if (item == data.pdbyq_000003) {
            //                     for (let key in data) {
            //                         if(key=='pdbyq_000003'){
            //                             treeColumList.push({
            //                                 colum_id: key,
            //                                 colum_value: _item.tree_type_id,
            //                             });
            //                         }else {
            //                             treeColumList.push({
            //                                 colum_id: key,
            //                                 colum_value: data[key],
            //                             });
            //                         }
            //                     }
            //                 }
            //             });
            //             const paramInner = {
            //                 tree_name: _item.tree_type_name,
            //                 tree_level: '40',
            //                 tree_type_id: _item.tree_type_id,
            //                 treeColumList: treeColumList,
            //             };
            //             deviceList.push(paramInner);
            //         }
            //     });
            // });
            return deviceList;
        },
        change(inject) {
            let rule = inject.rule;
            if (rule.length) {
                rule.forEach((item, index) => {
                    if (item.select == inject.self.field) {
                        this.rule[index].options = this[`options${index}`];
                    }
                });
                this.resetVal(inject.self.field, rule);
            }
        },
        resetVal(pId, arr) {
            for (const key in arr) {
                if (arr[key].select && arr[key].select == pId) {
                    let item = arr[key];
                    this.$set(item, "value", "");
                    this.resetVal(arr[key].field, arr);
                }
            }
        },
        collapesCb(collapes) {
            this.width = collapes ? "630px" : "849px";
        },
        // 分页器公共方法
        paginationDataNew(sth) {
            this.paginationData = sth;
            this.getDeviceLedgerList();
        },
    },
    watch: {
        treeId(newVal) {
            if (newVal) {
                this.commitForm.tableData = [];
                this.checkList = [];
                this.paginationData = {
                    pageNum: "1",
                    pageSize: "10",
                    totalNum: "",
                };
                this.tableId = newVal;
                this.tableList = [];
                this.getDeviceLedgerList();
            }
        },
    },
};
</script>
<style lang="scss">
.four_table {
    width: 100%;
    height: calc(100% - 110px);
    box-sizing: border-box;
    .equipment_scroll {
        margin-right: -1px;
    }
    .equipment_add_b {
        display: flex;
        flex-direction: row;
        height: 26rem;
        .el-card1 {
            width: 200px;
            height: 100%;
        }
        .right_container {
            width: calc(100% - 200px);
            height: 100%;
        }
        .collapes-block-container {
            height: auto !important;
        }
        .table-wrap-inner {
            background: none;
            padding: 0 !important;
        }
        .el-checkbox {
            width: 100%;
            color: #fff;
            margin: 5px 0 0 0;
        }
        .table-wrap-inner {
            height: 100%;
        }
        .el-input__inner {
            width: 100px;
            background: transparent;
            // color: #fff;
        }
    }
    .footer {
        text-align: center;
    }
    .leader-common-button {
        width: auto !important;
    }
    .inputCont {
        padding: 8px 0;
        margin: 0 !important;
    }
    .el-dialog {
        width: 1000px;
    }
    .leader-dialog .el-form-item {
        margin-bottom: 20px !important;
    }
    .leader-style-form {
        &::after {
            height: 0;
        }
    }
    .circle_wrapper {
        border: 3px solid #1a6292;
        padding: 30px 20px 0 30px;
        margin: 8px 0 20px 0;
        position: relative;
        .circle_title {
            position: absolute;
            top: -0;
            left: 20px;
            transform: translate(0, -50%);
            color: #fff;
            background-color: #0b1929;
            font-size: 14px;
        }
    }
    .leader-style-table .el-table__body-wrapper {
        height: 90% !important;
    }
    .color_green {
        color: #009788;
    }
    .color_red {
        color: red;
    }
    .leader-tab {
        position: relative;
        .btnContainer {
            width: auto;
            position: absolute;
            right: 32px;
            top: -29px;
        }
    }
}
</style>